import { action } from 'satcheljs';

export const onManagePageInitialized = action('onManagePageInitialized');
